export const MAX_HISTORY_SIZE = 20;
export const MAX_HISTORY_BYTES = 32 * 1024 * 1024;

export function captureHistoryImage(canvas) {
  if (canvas._useWebGL || canvas.width * canvas.height * 4 > MAX_HISTORY_BYTES) return null;
  return canvas.getContext('2d')?.getImageData(0, 0, canvas.width, canvas.height) || null;
}

// Retain all 20 navigation steps, but only cache recent images within the byte
// budget. Older steps still undo correctly by rendering their stored ranges.
export function appendHistory(history, entry) {
  const next = [...history, entry].slice(-MAX_HISTORY_SIZE);
  let bytes = 0;
  return next.reverse().map(item => {
    const size = item.imageData?.data?.byteLength || 0;
    bytes += size;
    return bytes > MAX_HISTORY_BYTES && item.imageData ? { ...item, imageData: null } : item;
  }).reverse();
}
